<template>
  <div>
    <el-card shadow="always">
      <el-page-header
        title="Home"
        @back="$router.push('/home').catch(() => {})"
        :content="$t('atendimentos')"
      ></el-page-header>
    </el-card>
    <br />
    <el-card>
      <el-row type="flex" justify="end">
        <el-col :xs="12" :sm="10" :md="10" :lg="5" :xl="5">
          <el-input
            :placeholder="$t('pesquisar')"
            prefix-icon="el-icon-search"
            v-model="filter"
          ></el-input>
        </el-col>
      </el-row>
      <el-table
        :data="
          tableData.filter(
            (data) =>
              !filter ||
              data.description.toLowerCase().includes(filter.toLowerCase()) ||
              data.code.toLowerCase().includes(filter.toLowerCase())
          )
        "
        stripe
        style="width: 100%"
        :default-sort="{ prop: 'name', order: 'ascending' }"
      >
        <el-table-column
          sortable
          prop="code"
          :label="$t('codigo')"
        ></el-table-column>
        <el-table-column
          sortable
          prop="route.description"
          :label="$t('Rota')"
        ></el-table-column>
        <el-table-column
          sortable
          prop="customer.name"
          :label="$t('cliente')"
        ></el-table-column>
        <el-table-column
          sortable
          prop="status"
          :label="$t('status')"
        ></el-table-column>
        <el-table-column width="180">
          <template slot-scope="scope">
            <el-button
              type="info"
              icon="el-icon-search"
              @click="editar(scope.row.id)"
              circle
            ></el-button>
            <el-button
              type="danger"
              icon="el-icon-delete"
              @click="remove(scope.row.id, scope.row.name)"
              circle
            ></el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-card>
  </div>
</template>
<script>
import { AttendanceService } from "@/services/umov/attendance.services";
import { i18n } from "@/plugin/i18n";

export default {
  name: "Attendance",
  methods: {
    fetchRecords() {
      const vm = this;
      const loading = vm.$loading({
        lock: true,
        text: i18n.tc("carregando"),
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });

      AttendanceService.list()
        .then(({ records }) => {
          records.forEach((item) => {
            item.code = item.code.toString().padStart(2, "0");

            switch (item.status) {
              case "1":
                item.status = "Iniciado";
                break;

              case "2":
                item.status = "Pausado";
                break;

              case "3":
                item.status = "Finalizado";
                break;

              default:
                item.status = "";
                break;
            }
          });
          vm.tableData = records;
        })
        .catch((error) => {
          vm.$notify.error({
            title: i18n.tc("erro"),
            message: error,
          });
        })
        .finally(() => loading.close());
    },

    add() {
      this.$router.replace({ name: "attendance.add" });
    },

    editar: function (id) {
      this.$router.replace({
        name: "attendance.edit",
        params: { id: id },
      });
    },

    remove: function (id, name) {
      const vm = this;
      this.$confirm(
        i18n.t("confirmar-eliminacao-atendimento", { role: name }),
        i18n.tc("aviso"),
        {
          confirmButtonText: "OK",
          cancelButtonText: i18n.tc("cancelar"),
          type: i18n.tc("aviso"),
          center: true,
        }
      ).then(() => {
        const loading = vm.$loading({
          lock: true,
          text: i18n.tc("carregando"),
          spinner: "el-icon-loading",
          background: "rgba(0, 0, 0, 0.7)",
        });

        AttendanceService.delete(id)
          .then((response) => {
            setTimeout(() => {
              const index = vm.tableData.findIndex((dt) => dt.id == id);
              vm.tableData.splice(index, 1);
            }, 300);
            this.$message({
              type: "success",
              message: i18n.tc("atendimento-eliminado-sucesso"),
            });
          })
          .catch((error) => {
            this.$message({
              type: "error",
              message: error,
            });
          })
          .finally(() => loading.close());
      });
    },
  },
  mounted() {
    const vm = this;
    vm.fetchRecords();
  },

  data() {
    return {
      filter: "",
      tableData: [],
    };
  },
};
</script>
<style>
.right {
  float: right;
}
</style>
